import { EcomHttpClient } from '../EcomHttpClient';
import { getStoreId } from './getStoreId';
import { getEcomInstance } from './getEcomInstance';
export var getEcomHttpClient = function (_a) {
    var flowAPI = _a.flowAPI, wixCodeApi = _a.wixCodeApi, instance = _a.instance, storeId = _a.storeId;
    instance = instance !== null && instance !== void 0 ? instance : getEcomInstance(wixCodeApi);
    storeId = storeId !== null && storeId !== void 0 ? storeId : getStoreId(instance);
    return new EcomHttpClient({
        instance: instance,
        wixCodeApi: wixCodeApi,
        csrfToken: flowAPI.controllerConfig.csrfToken,
        essentials: flowAPI.controllerConfig.essentials,
        storeId: storeId,
        isSSR: flowAPI.environment.isSSR,
        experiments: flowAPI.controllerConfig.essentials.experiments,
    });
};
//# sourceMappingURL=getEcomHttpClient.js.map